import getNextStep from '../elements/getNextStep';
import getStep from '../elements/getStep';
import getStepId from '../elements/getStepId';
import { classes } from '../elements/constants';
import getBranches from '../elements/getBranches';

export {
  getNextStep,
  getStep,
  getStepId,
  getBranches
};

export function isActiveStep(step) {
  return !!step && step.classList.contains(classes.active);
}

/**
 * Returns the highest number of steps needed to walk through a form.
 * @param {Element[]} steps - Array of form steps
 * @returns {Integer}
 */
export function getMaxSteps(steps) {
  return Math.max(
    ...getBranches(steps).map(branch => branch.filter(isCountable).length)
  );
}

/**
 * Returns true if the given step is counted as part of the progress bar
 */
export function isCountable(step) {
  return !step.dataset.actionName && step.querySelector('input:not([type=hidden])');
}
